import { render, staticRenderFns } from "./cancelar_gestion.vue?vue&type=template&id=9de927fe"
import script from "./cancelar_gestion.vue?vue&type=script&lang=js"
export * from "./cancelar_gestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports